import { getAdminThreshold, updateAdminThreshold } from "Adapters/APIs/Admin/settings";
import { getRestaurantBusiness } from "Adapters/APIs/Restaurant/Business";
import useSetDataInLocalStorage from "Hooks/useSetDataInLocalStorage";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useTopBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { getDataFromLocalStorage } = useSetDataInLocalStorage()
    const userData = getDataFromLocalStorage('user_data')
    const access_token = getDataFromLocalStorage('access_token')
    const defaultRoute = getDataFromLocalStorage('defaultRoute')

    // states
    const [showMenuPopup, setShowMenuPopup] = useState(false)
    const [adminSetting, setAdminSetting] = useState(false)
    const [adminThresholdData, setAdminThresholdData] = useState('')
    const [adminThresholdLoader, setAdminThresholdLoader] = useState(false)
    const [Notifications, setNotifications] = useState(false);
    const [showBusiness, setShowBusiness] = useState(false)
    const [logoutConfirmation, setLogoutConfirmation] = useState(false)
    const [loader, setLoader] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)
    const [secondLoader, setSecondLoader] = useState(false)

    // redux states
    const state = useSelector(state => state)
    const unread_count = state?.user?.unread_count
    const allBusinesses = state?.restaurantBusiness?.businesses_topbar
    const pagination_data = state?.restaurantBusiness?.pagination_data_topbar

    // get admin threshold data
    const getAdminThresholdData = () => {
        if (userData?.role == 'Super Admin') {
            const success = (res) => {
                setAdminThresholdData(res?.versions?.threshold)
            }
            const fail = () => {
            }
            dispatch(getAdminThreshold(access_token, success, fail))
        }
    }

    // update admin threshold data
    const updateAdminThresholdData = () => {
        setAdminThresholdLoader(true)
        let payload = {
            threshold: adminThresholdData
        }
        const success = () => {
            setAdminSetting(false)
            setAdminThresholdLoader(false)
            setShowMenuPopup(false)
            getAdminThresholdData()
        }
        const fail = () => {
            setAdminThresholdLoader(false)
        }
        dispatch(updateAdminThreshold(access_token, payload, success, fail))
    }

    // get all businesses
    const getAllBusinesses = () => {
        const success = (data) => {
            setLoader(false)
            setSecondLoader(false)
        }
        const fail = () => {
            setLoader(false)
            setSecondLoader(false)
        }
        let payload = {
            page: currentPage,
            per_page: 10,
            restaurant_id: userData?.restaurant?.id,
            topbar: true
        }
        if (currentPage == 1) {
            setLoader(true)
        } else {
            setSecondLoader(true)
        }
        dispatch(getRestaurantBusiness(access_token, payload, success, fail))
    }

    useEffect(() => {
        getAdminThresholdData()
        if(access_token && (defaultRoute == '/restaurant/dashboard')){
            getAllBusinesses()
        }
    }, [])

    return {
        showMenuPopup, setShowMenuPopup, userData, adminSetting, setAdminSetting, adminThresholdData, adminThresholdLoader,
        setAdminThresholdData, updateAdminThresholdData, Notifications, setNotifications, unread_count, navigate, defaultRoute, showBusiness,
        setShowBusiness, logoutConfirmation, setLogoutConfirmation, loader, allBusinesses, currentPage, setCurrentPage, secondLoader,
        pagination_data
    }
}
export default useTopBar